import React from 'react';
import PropTypes from 'prop-types';
import css from './TimelineItem.module.scss';
import Text from '../Text/Text';
import MutedText from '../Text/MutedText';
import FlexContainer from '../FlexContainer/FlexContainer';

const TimelineItem = ({title, timestamp, children}) => {
  return (
    <li className={css.item}>
      <FlexContainer className={css.header} alignItems="center" gap={6} flexFlow="row wrap">
        {title &&
          <Text weight="semibold">{title}</Text>
        }
        {title && timestamp &&
          <MutedText>·</MutedText>
        }
        {timestamp &&
          <MutedText size="small">{timestamp}</MutedText>
        }
      </FlexContainer>
      {children &&
        <FlexContainer alignItems="center" gap={6} flexFlow="row wrap" margin="4px 0 0">
          {children}
        </FlexContainer>
      }
    </li>
  );
};

TimelineItem.propTypes = {
  title: PropTypes.node,
  timestamp: PropTypes.node,
  children: PropTypes.node,
};

export default TimelineItem;
